import { FC, useContext } from 'react';
import { Box, Button, Popover, PopoverTrigger, PopoverContent, PopoverBody, useDisclosure, Text, Flex, Badge } from '@chakra-ui/react';
import { NotificationItem } from './NotificationItem';
import { useRouter } from 'next/router';
import { AuthContext, MPThemeContext } from 'providers';
import { usePersonalNotifications } from 'hooks/usePersonalNotifications';
import { CbInfiniteScroll } from '../CbInfiniteScroll';
import { Flipper } from 'react-flip-toolkit';
import { ICON_BY_NAME } from '../Icons/Icon';
export interface CbNotificationCenterProps {}
export const CbNotificationCenter: FC<CbNotificationCenterProps> = () => {
  const {
    auth
  } = useContext(AuthContext);
  const {
    personalNotifications,
    loadMore,
    markAllAsRead,
    markNotificationAsRead
  } = usePersonalNotifications({
    userId: auth?.id,
    rows_per_page: 10
  });
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const {
    isMobile
  } = useContext(MPThemeContext);
  const router = useRouter();
  const openNotifications = () => {
    onOpen();
  };
  const unreadNotifications = personalNotifications.filter(notification => !notification.readAt);
  const shouldShowMakeAllAsRead = unreadNotifications?.length > 0;
  const trigger = <Box position="relative">
      <Button onClick={openNotifications} _focus={{
      border: 'none'
    }} backgroundColor="luigisPants.400" _hover={{
      backgroundColor: 'luigisPants.400'
    }} borderRadius={50} size="sm">
        <ICON_BY_NAME.alarmbell height={4} width={4} color="samus.300" />
      </Button>
      {shouldShowMakeAllAsRead && <Badge position="absolute" top="-1" right="-1" borderRadius="full" variant="solid" colorScheme="red" fontSize="0.8em">
          {unreadNotifications?.length > 99 ? '99+' : unreadNotifications?.length}
        </Badge>}
    </Box>;
  const handleNotificationClick = (id: number, redirectLink: string) => {
    markNotificationAsRead(id);
    if (redirectLink) {
      router.push(redirectLink);
    }
    onClose();
  };
  return <Popover isOpen={isOpen} onClose={onClose} placement="bottom-end" data-sentry-element="Popover" data-sentry-component="CbNotificationCenter" data-sentry-source-file="CbNotificationCenter.tsx">
      <PopoverTrigger data-sentry-element="PopoverTrigger" data-sentry-source-file="CbNotificationCenter.tsx">
        <Box data-sentry-element="Box" data-sentry-source-file="CbNotificationCenter.tsx">{trigger}</Box>
      </PopoverTrigger>
      <PopoverContent border="none" boxShadow="0px 20px 100px rgba(0, 0, 0, 0.2)" borderRadius={8} width={isMobile ? '100vw' : '600px'} _focus={{
      boxShadow: '0px 30px 60px rgba(0, 0, 0, 0.1) !important',
      outline: 'none'
    }} data-sentry-element="PopoverContent" data-sentry-source-file="CbNotificationCenter.tsx">
        <Flex justifyContent="space-between" alignItems="center" paddingY={4} paddingLeft={{
        base: 4,
        md: 8
      }} paddingRight={2} data-sentry-element="Flex" data-sentry-source-file="CbNotificationCenter.tsx">
          <Text color="cloud.900" fontSize="24px" fontWeight="bold" data-sentry-element="Text" data-sentry-source-file="CbNotificationCenter.tsx">
            {'Notifications'}
          </Text>
          <Button color="chonky.400" fontWeight="bold" backgroundColor="transparent" onClick={markAllAsRead} isDisabled={!shouldShowMakeAllAsRead} data-sentry-element="Button" data-sentry-source-file="CbNotificationCenter.tsx">
            {'Mark all as read'}
          </Button>
        </Flex>
        <PopoverBody backgroundColor={'white'} borderRadius={8} paddingX={{
        base: 4,
        md: 5
      }} overflow="auto" height="600px" sx={{
        '::-webkit-scrollbar': {
          width: '7px'
        },
        '::-webkit-scrollbar-thumb': {
          borderRadius: '4px',
          backgroundColor: 'rgba(0, 0, 0, .3)',
          boxShadow: '0 0 1px rgba(255, 255, 255, .5)'
        }
      }} data-sentry-element="PopoverBody" data-sentry-source-file="CbNotificationCenter.tsx">
          <Flipper flipKey={personalNotifications} spring={{
          stiffness: 3000,
          damping: 200
        }} data-sentry-element="Flipper" data-sentry-source-file="CbNotificationCenter.tsx">
            {personalNotifications?.map((notification, index) => <NotificationItem key={index} notification={notification} onClick={handleNotificationClick} />)}
            <CbInfiniteScroll onOnScreen={loadMore} data-sentry-element="CbInfiniteScroll" data-sentry-source-file="CbNotificationCenter.tsx" />
          </Flipper>
        </PopoverBody>
      </PopoverContent>
    </Popover>;
};